export default __webpack_public_path__ + "static/media/confirm-icon.a23be943.svg";